import * as React from "react"
import type { SVGProps } from "react"
const SvgSidebarLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.5 15.37v-5.6q0-.35-.3-.47-.3-.13-.55.12L8.2 11.87a.96.96 0 0 0 0 1.4l2.45 2.45q.25.25.55.13.3-.13.3-.48M5 21.57q-.82 0-1.41-.59A2 2 0 0 1 3 19.57v-14q0-.82.59-1.41A2 2 0 0 1 5 3.57h14q.83 0 1.41.59.6.59.59 1.41v14q0 .82-.59 1.41a2 2 0 0 1-1.41.59zm11-2h3v-14h-3zm-2 0v-14H5v14z" />
  </svg>
)
export default SvgSidebarLeft
